import moment from 'moment';

/**
 *
 * @param {Object[]} employeeIds
 * @param {Object[]} shifts
 * @returns {Array[String[]]}
 */
const generateSchedulesHTMLTableRows = (employeeIds, shifts) => {
  const shiftsThisWeekCopy = [...shifts];

  // key - employee id, value - map
  const employeesObject = {};

  shiftsThisWeekCopy.forEach(shift => {
    const { employeeId, roomName, start, end, breakMinutes } = shift;
    const employeeInfo = employeeIds[parseInt(employeeId, 10)];

    if (!employeeInfo) {
      return;
    }

    const employeeName = employeeIds[employeeId].name || '';
    const formattedStart = moment(start).format('h:mm a');
    const formattedEnd = moment(end).format('h:mm a');
    // length of shift in minutes
    const minutesInShift = moment(end).diff(moment(start), 'minutes');
    // content of a table row cell
    const string = `${roomName}: ${formattedStart}-${formattedEnd}`;
    // map uses day of the week as its keys
    const dayOfWeek = moment(start).format('dddd').toLowerCase();
    // remove any break minutes, if any, from total amount worked
    const minutesWorkedForShift = minutesInShift - breakMinutes;

    if (employeesObject[employeeId] === undefined) {
      // use map since we want to preserve key order here
      let employeeMap = new Map([
        ['employeeId', employeeName],
        ['monday', []],
        ['tuesday', []],
        ['wednesday', []],
        ['thursday', []],
        ['friday', []],
        ['timeWorked', 0]
      ]);

      employeesObject[employeeId] = employeeMap;
    }

    // push a shift into its proper day
    const dayOfWeekArray = [...employeesObject[employeeId].get(dayOfWeek), string];
    // update time worked in minutes
    const minutesWorkedThisWeek = employeesObject[employeeId].get('timeWorked');
    const updatedMinutes = minutesWorkedThisWeek + minutesWorkedForShift;

    // update values in employee's map
    employeesObject[employeeId].set(dayOfWeek, dayOfWeekArray);
    employeesObject[employeeId].set('timeWorked', updatedMinutes);
  });

  /**
   * Right now we have an object where the key is an employee id and its value is a map.
   * We don't care about the ids so we create an array of every map.
   * Since we don't care about the keys of each map,
   * we transform the array from holding maps to holding an array of the values of each map
   */
  let employeeRows = Object.values(employeesObject).map(map => {
    // timeWorked is currently in minutes and we want to convert it to hours
    const timeWorked = map.get('timeWorked');
    const hoursWorked = parseFloat(timeWorked / 60).toFixed(2);

    map.set('timeWorked', hoursWorked);

    return Array.from(map.values());
  });

  // ensure the rows are sorted alphabetically. `employeeRows` is an array of arrays where the first index of each array is the employee's name.
  employeeRows.sort((emp1, emp2) => {
    const emp1Name = emp1[0];
    const emp2Name = emp2[0];
    const emp1LastName = emp1Name.split(' ')[1] || '';
    const emp2LastName = emp2Name.split(' ')[1] || '';

    if (emp1LastName.toLowerCase() < emp2LastName.toLowerCase()) {
      return -1;
    }

    if (emp1LastName.toLowerCase() > emp2LastName.toLowerCase()) {
      return 1;
    }

    return 0;
  });

  return employeeRows;
};

export default generateSchedulesHTMLTableRows;
